import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=2572f253&"
import script from "./PageResult.vue?vue&type=script&lang=js&"
export * from "./PageResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports